import { z } from 'zod';

import { LoanImportId, LoanImportRowId, LosId } from '../../BrandedIds';
import { ImportStatus } from '../../loan/LoanImport';
import { zodTemporalInstant } from '../../Temporal';

export const ExportableLoanImportRow = z
  .object({
    id: LoanImportRowId,
    loanImportId: LoanImportId,
    rowNumber: z.int(),
    losId: LosId.optional(), // preserved from the source file when present; null if the row failed before the LOS id could be parsed
    loanId: LosId.optional(), // unset for failed rows
    status: ImportStatus,
    failureReason: z.string().optional(), // populated when status = FAILED
    createdAt: zodTemporalInstant,
    updatedAt: zodTemporalInstant,
  })
  .meta({ title: 'LoanImportRow' });

export type ExportableLoanImportRow = z.infer<typeof ExportableLoanImportRow>;
